module.exports = __webpack_public_path__ + "2ebc5fc3cf5a78b9be81ce1d1f02db69.png";